<template>
  <div class="addAddress">
    <van-address-edit
      :show-detail="false"
      :area-list="areaList"
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      name="收货人"
      tel="手机号码"
      area="所在地区"
      area-placeholder="请选择所在地区"
      name-placeholder="请输入收货人姓名"
      tel-placeholder="请输入手机号码"
      :addressInfo="addressInfo"
      @save="onSave"
    >
      <template #default>
        <van-cell-group>
          <van-field
            style="
              font-size: 0.14rem;
              height: 0.44rem;
              padding: 0rem 0.15rem;
              line-height: 0.44rem;
            "
            v-model="address"
            label="详细地址"
            placeholder="请输入收货地址"
          />
        </van-cell-group>
      </template>
    </van-address-edit>
  </div>
</template>

<script>
import area from "./area";
import { addressFn } from "@/api/home.js";
export default {
  data() {
    return {
      areaList: {},
      addressInfo: {},
      address: "",
      params: "",
    };
  },
  created() {
    this.areaList = area;
    if (this.$route.params.item) {
      this.params = this.$route.params.item;
      sessionStorage.setItem(
        "addressItem",
        JSON.stringify(this.$route.params.item)
      );
    } else {
      this.params = JSON.parse(sessionStorage.getItem("addressItem"));
    }
    this.address = this.params.add;
    this.addressInfo = {
      id: this.params.id,
      name: this.params.name,
      tel: this.params.phone,
      province: this.params.province,
      city: this.params.city,
      county: this.params.area,
    };
    for (const i in this.areaList.county_list) {
      if (this.areaList.county_list[i] == this.params.area) {
        this.addressInfo.areaCode = i;
      }
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem("addressItem");
  },
  methods: {
    onSave(val) {
      const addressForm = {
        id: val.id,
        name: val.name,
        phone: val.tel,
        province: val.province,
        city: val.city,
        area: val.county,
        add: this.address,
        default: this.params.default,
      };
      addressFn(addressForm)
        .then((res) => {
          if (res.data.code == 0) {
            this.$router.replace("/shippingAddress");
          }
          this.$toast(res.data.msg);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang='scss'>
.addAddress {
  width: 100%;
  height: 100%;
  padding: 0.68rem 0 0.22rem 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .van-address-edit {
    padding: 0.15rem 0.15rem 0 0.15rem;
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    .van-address-edit__fields {
      .van-cell {
        font-size: 0.14rem;
        // height: 0.44rem;
        padding: 0rem 0.15rem;
        line-height: 0.44rem;
        .van-field__label {
          width: 0.79rem;
          margin: 0;
        }
      }
      .van-cell--clickable {
        .van-cell__value {
          .van-field__body {
            .van-field__right-icon {
              width: 0.06rem;
              height: 0.09rem;
              background: url("../../assets/img/btn_more@2x.png") no-repeat;
              background-size: contain;
              padding: 0;
              .van-icon-arrow {
                display: none;
                .van-icon-arrow::before {
                  content: "";
                }
              }
            }
          }
        }
      }
    }

    .van-address-edit__buttons {
      padding: 0;
      display: flex;
      justify-content: center;
      .van-button {
        padding: 0;
        margin-bottom: 0;
        width: 2.62rem;
        height: 0.44rem;
        border: none;
      }
      .van-button--danger {
        background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);
        border-radius: 0.22rem;

        font-size: 0.16rem;
        font-weight: bold;
        color: #93683d;
      }
    }
  }
}
</style>
